import { showLabelRequestsInReviewAPI, actionLabelRequestAdminAPI, deleteB2BFileAdminAPI, getSubAdminsListAdminAPI, assignUserToSubAdminsAPI } from "./api"

export function showLabelRequestsInReview(data) {
    return new Promise((resolve, reject) => {
        showLabelRequestsInReviewAPI(data)
            .then((res) => resolve(res))
            .catch((err) => reject(err));
    });
}

export function actionLabelRequestAdmin(data) {
    return new Promise((resolve, reject) => {
        actionLabelRequestAdminAPI(data)
            .then((res) => resolve(res))
            .catch((err) => reject(err));
    });
}

export function deleteB2BFileAdmin(data) {
    return new Promise((resolve, reject) => {
        deleteB2BFileAdminAPI(data)
            .then((res) => resolve(res))
            .catch((err) => reject(err));
    });
}

export function getSubAdminsListAdmin() {
    return new Promise((resolve, reject) => {
        getSubAdminsListAdminAPI()
            .then((res) => resolve(res))
            .catch((err) => reject(err));
    });
}

export function assignUserToSubAdmins(data) {
    return new Promise((resolve, reject) => {
        assignUserToSubAdminsAPI(data)
            .then((res) => resolve(res))
            .catch((err) => reject(err));
    });
}
